module.exports = __webpack_public_path__ + "static/media/ATS-V2-RPA.ec24613d.jpg";